import type * as CSS from 'csstype';
import { AspectRatio } from 'react-aspect-ratio';
import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { BASE_ASPECT_RATIO } from 'consts';
import { useParticipant } from 'core';
import { Avatar } from 'features/Avatar/Avatar';
import { RaiseHandIcon } from 'features/RaiseHand';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { ParticipantBar } from '../../components/ParticipantBar';
import { useParticipantItem, OrientationEnum } from '../../hooks/useParticipantItem';
import { MobileViewerPlaceholder, MobileViewerVideoRenderer, SIPCallIcon } from './view';

export const MobileViewerSIP = ({
    isAudioMuted,
    isVideoEnabled,
    isShowPulseAnimation,
    participant,
    onSizeChanged,
}: ParticipantPresenterProps) => {
    const { cameraPublication, isLocal } = useParticipant(participant);
    const { getObjectFit } = useParticipantItem();
    const objectFit: CSS.Properties['objectFit'] = getObjectFit(
        OrientationEnum.Landscape,
        cameraPublication?.dimensions,
    );
    const track = cameraPublication?.track;
    const isShowVideo = isVideoEnabled && track;

    const { getSIPParticipantName } = useSIPParticipant();
    const name = getSIPParticipantName(participant);

    const { checkIsHandRaised } = useRaiseHand();
    const handRaised = checkIsHandRaised(participant);

    return (
        <>
            <AspectRatio ratio={BASE_ASPECT_RATIO}>
                {isShowVideo && track ? (
                    <MobileViewerVideoRenderer
                        track={track}
                        isLocal={isLocal}
                        $objectFit={objectFit}
                        participantId={participant.identity}
                        onSizeChanged={onSizeChanged}
                    />
                ) : (
                    <Avatar
                        participant={participant}
                        PresenterPlaceholder={MobileViewerPlaceholder}
                        isShowPulseAnimation={isShowPulseAnimation}
                    >
                        <SIPCallIcon icon="icCall" />
                    </Avatar>
                )}
            </AspectRatio>
            <ParticipantBar isAudioMuted={isAudioMuted} name={name} />
            {handRaised && <RaiseHandIcon size={16} />}
        </>
    );
};
